import React from 'react'
import { useRecoilState } from "recoil";
import { query } from "../states/atoms/filtration";
import header2 from "../assets/bank-assets/background.jpg";
import { useTranslation } from "react-i18next";
import SearchIcon from "../assets/icons/search.svg";
import { isMobile } from "react-device-detect";

function Search() {
    const [_query, setQuery] = useRecoilState(query);
    //  console.log(_query);

    // eslint-disable-next-line
    const { t, i18n } = useTranslation();
    if (isMobile) {
        return (
            <section className="w-full" style={{
                backgroundImage: `url(${header2})`
            }}>
                {i18n.language === "fr" ? (
                    <div className="tw-container py-8 md:py-16">
                        <div className="flex items-center justify-center">
                            <div className="flex w-full justify-center">
                                <input type="text" className="px-4 py-2 mr-2 w-80 rounded-md"
                                    value={_query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="Rechercher produit, référence..." />
                                <button
                                    className="hidden md:flex flex-row px-4 text-primary-color font-medium bg-secondary-color items-center rounded-md text-xl">
                                    <img alt={'...'} src={SearchIcon} className='w-6 lg:w-6 mx-2 ' />
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="tw-container py-8 md:py-16">
                        <div className="flex items-center justify-center">
                            <div className="flex">
                                <button
                                    className="hidden md:flex flex-row px-4 text-primary-color font-medium bg-secondary-color items-center justify-center rounded-md text-xl">
                                    {t("search.searchbtn")}
                                    <img alt={'...'} src={SearchIcon} className='w-0 lg:w-6 mx-2' />
                                </button>
                                <input type="text" className="px-4 py-2 ml-2 w-80 rounded-md text-right"
                                    value={_query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="بحث عن منتج ، مرجع ..." />
                            </div>
                        </div>
                    </div>
                )}
            </section>
        )
            ;
    } else {
        return (
            <section style={{
                backgroundImage: `url(${header2})`
            }}>
                {i18n.language === "fr" ? (
                    <div className="tw-container py-8 md:py-16">
                        <div className="flex items-center justify-center">
                            <div className="flex w-full justify-center">
                                <input type="text" className="px-4 py-2 mr-2 w-80 rounded-md"
                                    value={_query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="Rechercher produit, référence..." />
                                <button
                                    className="flex flex-row px-4 text-primary-color font-medium bg-secondary-color items-center rounded-md text-xl">
                                    <img alt={'...'} src={SearchIcon} className='w-0 lg:w-6 mx-2' />
                                    {t("search.searchbtn")}
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="tw-container py-8 md:py-16">
                        <div className="flex items-center justify-center">
                            <div className="flex">
                                <button
                                    className="flex flex-row px-4 text-primary-color font-medium bg-secondary-color items-center justify-center rounded-md text-xl">
                                    {t("search.searchbtn")}
                                    <img alt={'...'} src={SearchIcon} className='w-0 lg:w-6 mx-2' />
                                </button>
                                <input type="text" className="px-4 py-2 ml-2 w-80 rounded-md text-right"
                                    value={_query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder="بحث عن منتج ، مرجع ..." />
                            </div>
                        </div>
                    </div>
                )}
            </section>
        )
            ;
    }

}

//
// Breadcrumbs.propTypes = {
//     children: PropTypes.node.isRequired
// }

export default Search